package com.evoapps.evoshift.domain.repository

import com.evoapps.evoshift.domain.model.MaterializedCost
import com.evoapps.evoshift.domain.model.Roster
import com.evoapps.evoshift.domain.model.RosterPublication
import com.evoapps.evoshift.domain.model.RosterStatus
import kotlinx.coroutines.flow.Flow

interface RosterRepository {
    suspend fun getRoster(rosterId: String): Result<Roster>
    fun observeRoster(rosterId: String): Flow<Roster>
    fun observeRosters(workplaceId: String): Flow<List<Roster>>

    // Lifecycle
    suspend fun createRoster(workplaceId: String, month: Int, year: Int): Result<String>
    suspend fun deleteRoster(rosterId: String): Result<Unit>
    suspend fun publishRoster(rosterId: String): Result<Unit>
    /** SH-271: publishes with the [publication]'s version and changed people, in the same write as the status. */
    suspend fun publishRoster(rosterId: String, publication: RosterPublication): Result<Unit> = publishRoster(rosterId)
    suspend fun updateRosterStatus(rosterId: String, status: RosterStatus): Result<Unit>

    // Cost Materialization Trigger (Copies rules to roster/costs)
    suspend fun materializeCosts(rosterId: String, costs: List<MaterializedCost>): Result<Unit>

    suspend fun linkAvailabilityRequest(
        rosterId: String,
        availabilityRequestId: String
    ): Result<Unit>
}